import React from 'react';


const About = () => {
    return (
      <div>
        <h1> new child  </h1>
      </div>
    );
  }
  
export default About ;